export default function TrustSection() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-12 items-center">
          <div className="lg:w-[58%]">
            <div className="flex items-center gap-2 mb-8">
              <span className="w-2 h-2 rounded-full bg-foreground-800"></span>
              <span className="text-xs font-semibold text-foreground-600 uppercase tracking-wider">
                Avaliações Reais
              </span>
            </div>
            <blockquote className="font-serif text-2xl md:text-3xl lg:text-4xl text-foreground-900 leading-snug font-medium italic">
              &ldquo;A planilha hoobuy sheet economizou horas de busca. Produtos verificados e links que realmente funcionam.&rdquo;
            </blockquote>
            <div className="flex items-center gap-3 mt-6">
              <div>
                <p className="text-sm font-bold text-foreground-900">
                  Carlos M.
                </p>
                <div className="flex items-center gap-1.5 mt-0.5">
                  <span className="w-3.5 h-3.5 flex items-center justify-center text-secondary-500">
                    <i className="ri-star-fill text-sm"></i>
                  </span>
                  <span className="text-xs text-foreground-500">
                    Google Reviews
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:w-[42%] w-full">
            <div className="w-full h-[400px] md:h-[500px] overflow-hidden rounded-2xl bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20black%20and%20white%20editorial%20portrait%20of%20a%20fashion%20conscious%20young%20adult%20gazing%20thoughtfully%20upward%2C%20three%20quarter%20profile%20angle%2C%20clean%20bright%20studio%20lighting%2C%20minimalist%20white%20backdrop%2C%20high%20contrast%20dramatic%20shadows%2C%20contemporary%20fashion%20editorial%20mood%2C%20natural%20expression%2C%20fine%20art%20portrait%20style%2C%20timeless%20composition&width=600&height=800&seq=testimonial-v2-portrait&orientation=portrait"
                alt="Avaliação Hoobuy Spreadsheet"
                title="Usuário satisfeito com Hoobuy Spreadsheet"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}